import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractAppConfig } from '../../../app.config';

@Injectable()
export class HeadersSanitisingInterceptor implements HttpInterceptor {

  private static readonly HEADER_ACCEPT = 'Accept';
  private static readonly HEADER_CONTENT_TYPE = 'Content-Type';

  constructor(private appConfig: AbstractAppConfig) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(this.sanitise(request));
  }

  private sanitise(request: HttpRequest<any>) {

    let finalHeaders = request.headers;
    if (!finalHeaders.has(HeadersSanitisingInterceptor.HEADER_ACCEPT)) {
      finalHeaders = finalHeaders.set(HeadersSanitisingInterceptor.HEADER_ACCEPT, 'application/json');
    }

    if (this.doSetContentTypeHeader(finalHeaders, request)) {
      finalHeaders = finalHeaders.set(HeadersSanitisingInterceptor.HEADER_CONTENT_TYPE, 'application/json');
    }

    // Clone immutable request with sanitised headers
    return request.clone({
      headers: finalHeaders
    });
  }

  private doSetContentTypeHeader(finalHeaders, request) {
    return !(finalHeaders.has(HeadersSanitisingInterceptor.HEADER_CONTENT_TYPE) || this.isDocumentStorePut(request));
  }

  private isDocumentStorePut(request) {
    return request.url.startsWith(this.appConfig.getDocumentStoreUrl()) && request.method === 'PUT';
  }
}
